export default "__VITE_ASSET__DO5w84R9__"